import axios, { Canceler } from 'axios'
import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import {
  CreateQuantityTypeDto,
  IMessageResponseDto,
  IQuantityTypesRespDto,
  UpdateQuantityTypeDto,
  IQuantityTypeChangesRespDto,
} from 'src/types'

class QuantityTypesService extends EnhancedWithAuthHttpService {
  CancelToken
  cancel?: Canceler

  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }

  getQuantityTypes(params?: {}) {
    if (this.cancel) {
      this.cancel()
    }
    return this.get<IQuantityTypesRespDto>('quantity-types', {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.cancel = c
      }),
    })
  }

  getQuantityTypeChanges(id: string) {
    return this.get<IQuantityTypeChangesRespDto>(`quantity-types/${id}/changes`)
  }

  createCategoryValue(dto: CreateQuantityTypeDto) {
    return this.post<IMessageResponseDto, CreateQuantityTypeDto>('quantity-types', dto)
  }

  updateQuantityType(id: string, dto: UpdateQuantityTypeDto) {
    return this.put<IMessageResponseDto, UpdateQuantityTypeDto>(`quantity-types/${id}`, dto)
  }

  removeQuantityTypes(ids: string[]) {
    return this.delete<IMessageResponseDto>(`quantity-types`, { data: { ids } })
  }
}

export const quantityTypesService = new QuantityTypesService()
export default QuantityTypesService
